// removed by extract-text-webpack-plugin
module.exports = {"monospace-font-family":"'Roboto Mono', monospace","ixt-blue":"#003B5C","ixt-blue-300":"#80a8c6","ixt-red":"#FF5555"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CatalogSpecimenPreview.css
// module id = 569
// module chunks = 2